module.exports = __webpack_public_path__ + "media/images/logos/University-of-Bath-bb22036dd8b7b48718e765423f1e6abe.svg";